export enum TrackingDataFieldTypeOtpScenario {
  Signup = 'sign_up',
  LoginWithSms = 'login_with_sms',
  LoginWithPassword = 'login_with_password',
  ResetPassword = 'reset_password',
  AccountLinkingChangePhone = 'account_linking_change_phone',
  AccountLinkingAddPhone = 'account_linking_add_phone',
  AccountLinkingVerifyPhone = 'account_linking_verify_phone',
  AccountLinkingChangeEmail = 'account_linking_change_email',
  AccountLinkingAddEmail = 'account_linking_add_email',
  AccountLinkingVerifyEmail = 'account_linking_verify_email',
  AddPhone = 'add_phone',
  ReloginWithPhone = 'relogin_with_phone',
  OneCredentialDelink = 'delink_onecredential',
  ThirdPartyLogin = 'third_party_login',
}

export type TrackingDataFieldOTP = {
  scenario:
    | TrackingDataFieldTypeOtpScenario
    | TrackingDataFieldTypePhoneAlreadyUsedScenario;
};
export type TrackingDataOTPProps = {
  scenario:
    | TrackingDataFieldTypeOtpScenario
    | TrackingDataFieldTypePhoneAlreadyUsedScenario;
};

export enum TrackingDataFieldTypePhoneAlreadyUsedScenario {
  AccountLinkingChangePhone = TrackingDataFieldTypeOtpScenario.AccountLinkingChangePhone,
  AccountLinkingAddPhone = TrackingDataFieldTypeOtpScenario.AccountLinkingAddPhone,
  AccountLinkingVerifyPhone = TrackingDataFieldTypeOtpScenario.AccountLinkingVerifyPhone,
  AddPhone = TrackingDataFieldTypeOtpScenario.AddPhone,
}

export enum TrackingDataFieldTypeEmailAlreadyUsedScenario {
  AccountLinkingChangeEmail = TrackingDataFieldTypeOtpScenario.AccountLinkingChangeEmail,
  AccountLinkingAddEmail = TrackingDataFieldTypeOtpScenario.AccountLinkingAddEmail,
}

export type TrackingDataFieldPhoneAlreadyUsed = {
  scenario: TrackingDataFieldTypePhoneAlreadyUsedScenario;
};
export type TrackingDataPhoneAlreadyUsedProps = {
  scenario: TrackingDataFieldTypePhoneAlreadyUsedScenario;
};

export type TrackingDataFieldEmailAlreadyUsed = {
  scenario: TrackingDataFieldTypeEmailAlreadyUsedScenario;
};
export type TrackingDataEmailAlreadyUsedProps = {
  scenario: TrackingDataFieldTypeEmailAlreadyUsedScenario;
};

export type TrackingDataFieldOtpVerificationResult = {
  scenario: TrackingDataFieldTypeOtpScenario;
  verification_result: 0 | 1;
};
export type TrackingDataOtpVerificationResultProps = {
  scenario: TrackingDataFieldTypeOtpScenario;
  hasError: boolean;
};
